import React from 'react';
import './get-in-touch.css';
import './index.css';
import Footer from './components/footer';
import BannerSection from './components/banner';
import cristi from './assets/cristi.png';
import tatiana from './assets/Tatiana.png';
import GetInTouchForm from "./components/get-in-touch";
import HeaderBlack from "./components/header-black";


const TeamImage = ({src, className, name, title}) => {
    return (
        <div className="team-image">
            <div className="image-outer">
                <img src={src} alt={name} className={className}/>

                <div className="i-name">{name}</div>
                <div className="i-title b2">{title}</div>
            </div>
        </div>
    );
}

class Team extends React.Component {
    render() {
        return (
                <div className='team-outer page-padding space-above mb-15'>
                    <div className='t2 mb-5'>Our team</div>

                    <div className='two-cols'>
                        <div className='team-member-col'>
                            <TeamImage src={cristi} name="Cristian Lupascu" title="Software Engineer"/>
                            <div className='b2 mt-4'>
                                I am dedicated to continuously developing, implementing, and adopting new technologies and produce innovative applications. I am continuously in search of new challenges, testing my abilities and to gain new ones.
                                <br/><br/>
                                I am most experienced in web development and android development but I have a wide range of interests and curiosities: blockchain, cybersecurity, various scripting languages, electronics, AI, machine learning. I am open to networking with like-minded people and is interested in new challenges.
                            </div>
                        </div>

                        {/* <div className='team-member-col'>
                            <TeamImage className='adjust-image' src={tatiana} name="Gina Vitan" title="UI/UX Designer"/>
                            <div className='b2 mt-4'>
                                With 14 years in UI/UX design, I’ve helped shape everything from sleek mobile apps to complex web platforms. Design Director at RivetHammer (Seattle-based) for over 10 years, leading product design and creative strategy across a wide range of digital projects.
                                <br/><br/>
                                I love turning messy ideas into clean, intuitive experiences people actually enjoy using. I thrive on collaboration, working closely with product teams, developers, and users to bring ideas to life.
                                Big fan of pixel-perfect design, thoughtful details, and keeping things smart and simple.
                            </div>
                        </div> */}
                    </div>
                </div>
            );
    }
}

class GetInTouch extends React.Component {
    sendEvent = () => {
        if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        if(!sessionStorage.getItem('get-in-touch-page')) {
            sessionStorage.setItem('get-in-touch-page', true);

            fetch('https://api.ipify.org?format=json')
                .then((ipResp) => ipResp.json().then((ipJson) => {
                    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({type: 'get-in-touch', name: 'binaryfusion.ro', from: ipJson}),
                    }).then((response) => response.json().then((responseData) => {
                        sessionStorage.setItem('success', responseData.EventId);
                    }));
                })
            );

        }
    }

    componentDidMount() {
        this.sendEvent();
        
        window.scrollTo(0, 0);

        const head = document.head;
        const url = `https://www.binaryfusion.ro/get-in-touch`;

        // Check if a canonical link already exists
        let link = document.querySelector("link[rel='canonical']");

        if (link) {
            // Update existing link
            link.setAttribute("href", url);
        } else {
            // Create a new link element
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            link.setAttribute("href", url);
            head.appendChild(link);
        }
    }
    

    render() {
        return (
            <div id="get-in-touch-page">
                <HeaderBlack />

                <GetInTouchForm />

                <Team />

                <BannerSection />

                <Footer/>
                
            </div>
        );
    }
}

export default GetInTouch;